import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaYoutube,
  FaFilePdf
} from "react-icons/fa";
import androidAppImg from "../assets/googleplay.png";
import brochure from "../assets/brochure.pdf";

const Footer = () => {
  return (
    <>
      {/* Decorative Top Curve */}
      <div className="footer-curve">
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path
            d="M0,100 C480,0 960,150 1440,0 L1440,100 L0,100 Z"
            fill="#2874F0"
          />
        </svg>
      </div>

      <footer className="custom-footer">
        <div className="footer-top">
          {/* Column 1 - Logo & About */}
          <div className="footer-col footer-logo-col">
            <img
              src="/logo.png"
              alt="Sangit Shree Logo"
              className="footer-logo-img"
            />
            <p className="footer-desc">
              Publisher and distributor of Hindustani Classical Music Books
            </p>
            <a
              href={brochure}
              download
              className="footer-brochure-btn"
            >
              <FaFilePdf /> Download Brochure
            </a>
          </div>

          {/* Column 2 - Address */}
          <div className="footer-col footer-address-col">
            <h4>Address</h4>
            <p className="footer-address">
              Shop No. 116,<br />
              Nagar Nigam Market,<br />
              Vikas Nagar, Gurudev Zoo Rd.<br />
              In front of: Manorma Marriage Palace,<br />
              Kanpur - 208002, Uttar Pradesh, India
            </p>
          </div>

          {/* Column 3 - Contact Info */}
          <div className="footer-col footer-contact-col">
            <h4>Contact Us</h4>
            <ul>
              <li>
                <a href="tel:+917408452828">
                  <FaPhoneAlt /> +91 740-845-2828
                </a>
              </li>
              <li>
                <a href="tel:+919336112507">
                  <FaPhoneAlt /> +91 933-611-2507
                </a>
              </li>
              <li>
                <a href="mailto:sangitshreeprakashan@gmail.com">
                  <FaEnvelope /> sangitshreeprakashan@gmail.com
                </a>
              </li>
              <li>
                <a href="mailto:info@sangitshreeprakashan.com">
                  <FaEnvelope /> info@sangitshreeprakashan.com
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Download App */}
          <div className="footer-col footer-download-col">
            <h4>Download App</h4>
            <a
              href="https://play.google.com/store/apps/details?id=com.sangitnew"
              target="_blank"
              rel="noreferrer"
              className="footer-app-card"
            >
              <img
                src={androidAppImg}
                alt="Android App"
                className="footer-app-img"
              />
              <div className="footer-app-text">
                <span className="footer-app-title">Android App</span>
                <span className="footer-app-sub">Get it on Google Play</span>
              </div>
            </a>
          </div>

          {/* Column 5 - Social Media */}
          <div className="footer-col footer-connect-col">
            <h4>Connect With Us</h4>
            <div className="footer-social-icons">
              <a
                href="https://wa.me/917408452828"
                target="_blank"
                rel="noreferrer"
              >
                <FaWhatsapp /> WhatsApp
              </a>
              <a
                href="https://www.facebook.com/share/16kEyghmCW/"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebookF /> Facebook
              </a>
              <a
                href="https://www.instagram.com/sangitshreeprakashan?igsh=MW1pZ2h4ZDJxaTczMQ=="
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram /> Instagram
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noreferrer"
              >
                <FaYoutube /> YouTube
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-copy">
            © {new Date().getFullYear()} Sangit Shree Prakashan. All rights reserved.
          </div>

          <div className="footer-privacy" style={{ marginTop: "8px" }}>
            <Link
              to="/privacy"
              style={{
                color: "#2874F0",
                fontWeight: "600",
                textDecoration: "none",
              }}
            >
              Privacy Policy
            </Link>
          </div>

          <div className="footer-powered">
            Powered by{" "}
            <a
              href="https://www.codesaarthi.com"
              target="_blank"
              rel="noreferrer"
            >
              Codesaarthi.com
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
